import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useEvent } from '@/hooks/useEvent'
import { supabase } from '@/lib/supabaseClient'
import { PageSpinner, StatTile, Card, Button } from '@/components/ui'

interface Stats {
  hotels: number
  companies_total: number
  rooms_allocated: number
  rooms_occupied: number
  guest_capacity: number
  guests_entered: number
  companies_open: number
  companies_closed: number
  companies_completed: number
}

export default function Dashboard() {
  const { event } = useEvent()
  const [stats, setStats] = useState<Stats | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    supabase
      .rpc('admin_event_dashboard_stats', { p_event_id: event.id })
      .then(({ data }) => setStats(data as Stats))
  }, [event.id])

  if (!stats) return <PageSpinner label="Loading dashboard…" />

  const remaining = stats.guest_capacity - stats.guests_entered

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        <StatTile label="Companies" value={stats.companies_total} />
        <StatTile label="Hotels" value={stats.hotels} />
        <StatTile label="Rooms Allocated" value={stats.rooms_allocated} />
        <StatTile label="Rooms Occupied" value={stats.rooms_occupied} />
        <StatTile label="Guest Capacity" value={stats.guest_capacity} />
        <StatTile label="Guests Entered" value={stats.guests_entered} />
        <StatTile label="Remaining Guest Slots" value={remaining} />
        <StatTile label="Companies Completed" value={`${stats.companies_completed} / ${stats.companies_total}`} />
        <StatTile label="Open Companies" value={stats.companies_open} />
        <StatTile label="Closed Companies" value={stats.companies_closed} />
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <Card className="p-5">
          <h3 className="text-sm font-semibold text-slate-900">Companies</h3>
          <p className="mt-1 text-sm text-slate-500">Add companies, allocate rooms, manage links and deadlines.</p>
          <Button className="mt-3" onClick={() => navigate(`/admin/events/${event.id}/companies`)}>
            Open Companies
          </Button>
        </Card>
        <Card className="p-5">
          <h3 className="text-sm font-semibold text-slate-900">Rooming List</h3>
          <p className="mt-1 text-sm text-slate-500">Search and filter every room across all companies and hotels.</p>
          <Button className="mt-3" onClick={() => navigate(`/admin/events/${event.id}/rooming-list`)}>
            Open Rooming List
          </Button>
        </Card>
        <Card className="p-5">
          <h3 className="text-sm font-semibold text-slate-900">Import / Export</h3>
          <p className="mt-1 text-sm text-slate-500">Bulk-import companies from Excel, or export the final rooming list.</p>
          <Button className="mt-3" onClick={() => navigate(`/admin/events/${event.id}/import-export`)}>
            Open Import / Export
          </Button>
        </Card>
      </div>
    </div>
  )
}
